/**
 * @generated SignedSource<<731a427bb9c9e0cba9608a62d963902f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePantoneColorsCheckQuery$variables = Record<PropertyKey, never>;
export type usePantoneColorsCheckQuery$data = {
  readonly hasPantoneColors: boolean;
};
export type usePantoneColorsCheckQuery = {
  response: usePantoneColorsCheckQuery$data;
  variables: usePantoneColorsCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasPantoneColors",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePantoneColorsCheckQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePantoneColorsCheckQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "207bb2912d9348533f75470691967b8d",
    "id": null,
    "metadata": {},
    "name": "usePantoneColorsCheckQuery",
    "operationKind": "query",
    "text": "query usePantoneColorsCheckQuery {\n  hasPantoneColors\n}\n"
  }
};
})();

(node as any).hash = "db107161c550e6a541b16b871f6f9a25";

export default node;
